import { render, staticRenderFns } from "./SubscriptionPanel.vue?vue&type=template&id=23c37f39&scoped=true&"
import script from "./SubscriptionPanel.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPanel.vue?vue&type=style&index=0&id=23c37f39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c37f39",
  null
  
)

export default component.exports